function cleanValues(data) {
  return Object.entries(data).reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    // delete any undefined values
    if (typeof value === 'boolean' || value) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
export default cleanValues;